import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { MyUtils } from "src/app/services/my-utils.service";

export interface Logout {
  title: "";
  question: "";
  yes: "";
  no: "";
}

@Component({
  selector: "app-yes-no-dialog",
  templateUrl: "./yes-no-dialog.component.html",
  styleUrls: ["./yes-no-dialog.component.css"],
})
export class YesNoDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Logout,
    private authService: AuthService,
    private router: Router,
    public utility: MyUtils,
    private dialogRef: MatDialogRef<YesNoDialogComponent>
  ) {}

  ngOnInit() {}

  action(event: boolean) {
    this.dialogRef.close(event)
  }

  
}
